/**
 * Alamat API.
 *
 * Dalam produksi, SPA (`app.72on.com`) dan API (`api.72on.com`) berada pada hos berbeza, jadi
 * `window.location.origin` salah. Nilai ditanam semasa binaan melalui `VITE_API_BASE`.
 *
 * Dalam pembangunan, lalai kembali kepada origin semasa kerana `tools/serve-dist.mjs` mengproksikan
 * `/v1` ke API tempatan.
 */

const configured = import.meta.env.VITE_API_BASE as string | undefined;

export const API_BASE =
  configured !== undefined && configured !== '' ? configured.replace(/\/+$/, '') : window.location.origin;

/**
 * Cap masa binaan.
 *
 * Semasa menyokong kedai, soalan pertama ialah "versi mana yang sedang berjalan?". Tanpa ini,
 * mustahil membezakan "pembetulan belum deploy" daripada "pembetulan tidak berkesan" — dan
 * perbezaan itu menentukan siapa yang perlu bertindak.
 */
export const BUILD_VERSION = (import.meta.env.VITE_BUILD_VERSION as string | undefined) ?? 'pembangunan';
